export default  {
    component: 'inverter_param',
    name: 'inverter_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            type: 'text',
            description: `Their are 2 options for module:
            - **live** 
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **live** [Parameter Options : dc_voltage,dc_power,ac_power,inverter_temp]
            - **analytics** [Parameter Options : l1_ac_vlg, l1_ac_current, ac_power, ac_frequency, dc_power, dc_current, ac_energy, energy_today, dc_voltage, reactive_power]`
          }
    ]
  }
